import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { useTranslate } from 'react-admin'
import SentimentDissatisfiedIcon from '@material-ui/icons/SentimentDissatisfied'
import CreditCardIcon from '@material-ui/icons/CreditCard'
import unauthorizedPageStyles from './unauthorizedPage.styles'
import ConditionalRender from '../../components/ConditionalRender/ConditionalRender'
import UNAUTHORIZED_REASONS from '../../utils/constants/unauthorizedReasons'
import ButtonWithLoader from '../../components/ui/ButtonWithLoader/ButtonWithLoader'
import useHistoryPush from '../../hooks/useHistoryPush'
import COLORS from '../../utils/constants/colors'
import USER_PERMISSIONS from '../../utils/constants/userPermissions'
import hasPermission from '../../utils/helpers/hasPermission'

const UnauthorizedPage = ({ reason }) => {
  const translate = useTranslate()
  const { redirect } = useHistoryPush()
  const useStyles = makeStyles(unauthorizedPageStyles)
  const classes = useStyles()

  const isSubscriptionReason = reason === UNAUTHORIZED_REASONS.SUBSCRIPTION
  const Icon = isSubscriptionReason ? CreditCardIcon : SentimentDissatisfiedIcon

  const header = isSubscriptionReason
    ? 'ra.text.unauthorizedPaymentHeader'
    : 'ra.text.unauthorizedPageHeader'
  const main = isSubscriptionReason
    ? 'ra.text.unauthorizedPaymentMain'
    : 'ra.text.unauthorizedPageMain'

  return (
    <div className={classes.flexCont}>
      <Icon
        style={{
          width: '40%',
          height: '40%',
          fill: COLORS.orange,
          opacity: 0.5,
        }}
      />
      <p className={classes.flexText}>{translate(header)}</p>
      <p className={classes.flexText}>{translate(main)}</p>

      <ConditionalRender renderValue={hasPermission(USER_PERMISSIONS.DO_BILLING)}>
        <ButtonWithLoader
          label={
            isSubscriptionReason
              ? translate('ra.buttons.completeSubscription')
              : 'See Subscription'
          }
          onClick={() => {
            // The overview tab holds the billing summary and the Subscribe button; the first
            // payment collects the card on Viva's checkout, so no separate add-card step.
            redirect('/subscription')
          }}
        />
      </ConditionalRender>
    </div>
  )
}

UnauthorizedPage.propTypes = {
  reason: PropTypes.oneOf(Object.values(UNAUTHORIZED_REASONS)),
}

UnauthorizedPage.defaultProps = {
  reason: UNAUTHORIZED_REASONS.ACCESS,
}

export default UnauthorizedPage
